import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import Styled from 'styled';

import SVGIcon from 'lib/images/svg-icon/svg-icon';
import FormattedDateAgoView from 'lib/intl/formatted-date-ago-view';

import reply from 'four-nets/icons/svg/icon_reply.svg';
import like from 'four-nets/icons/svg/icon_like.svg';
import like2 from 'four-nets/icons/svg/icon_like-2.svg';
import clock from 'four-nets/icons/svg/icon_time.svg';
import others from 'four-nets/icons/svg/icon_others.svg';

import LikersDialog from 'four-nets/photoblog/posts/common/comments/comment-likers/comment-likers-dialog/comment-likers-dialog';
import { HideForUnpaidVendor } from 'four-nets/vendor/permissions';
import { AuthOrigin } from 'four-nets/user/auth/auth-ga-events';

import clockIconStyles from './clock-icon.scss';
import defaultStyles from './footer.scss';
import { CommentFooterFragment } from './footer.graphql';
import LikeUnlikeComment from './like-unlike-comment';
import CommentMore from './comment-more/comment-more';

export interface Props extends CommentFooterFragment {
    post: CommentFooterFragment['post'];
    onComment?: React.MouseEventHandler<HTMLButtonElement>;
    createdTime: string;
    styles: typeof defaultStyles;
}

interface State {
    open: boolean;
    moreOpen: boolean;
}

class Footer extends React.PureComponent<Props, State> {
    state: State = { open: false, moreOpen: false };

    static contextTypes = {
        authCheck: PropTypes.func,
    };

    open = () => {
        this.setState({ open: true });
    };

    close = () => {
        this.setState({ open: false });
    };

    openMore = () => {
        this.setState({ moreOpen: true });
    };

    closeMore = () => {
        this.setState({ moreOpen: false });
    };

    render() {
        const { styles, onComment, createdTime, post, ...comment } = this.props;
        const { isLikedByViewer, likesCount } = comment;

        const { open, moreOpen } = this.state;

        return (
            <div className={styles.buttons}>
                <div className={styles.createdTime}>
                    <SVGIcon style={{ image: clockIconStyles.icon }} src={clock} />
                    <FormattedDateAgoView value={new Date(createdTime)} />
                </div>
                <div className={styles.divider} />
                <button
                    className={classnames(styles.count, { [styles.isZero]: !Boolean(likesCount) })}
                    onClick={this.open}
                    disabled={!Boolean(likesCount)}
                >
                    <SVGIcon style={{ image: styles.icon }} src={likesCount ? like2 : like} />
                    {likesCount || null}
                </button>
                <LikersDialog {...comment} open={open} onClose={this.close} />
                <LikeUnlikeComment {...comment}>
                    {(likeComment, unlikeComment) => (
                        <HideForUnpaidVendor>
                            <button
                                className={styles.button}
                                onClick={() =>
                                    this.context.authCheck(
                                        () => (!isLikedByViewer ? likeComment() : unlikeComment()),
                                        AuthOrigin.LikeComment
                                    )
                                }
                            >
                                {isLikedByViewer ? <FormattedMessage id='UNLIKE' /> : <FormattedMessage id='LIKE' />}
                            </button>
                        </HideForUnpaidVendor>
                    )}
                </LikeUnlikeComment>
                <div className={styles.divider} />
                <button onClick={onComment} className={styles.button}>
                    <SVGIcon style={{ image: styles.icon }} src={reply} />
                    <FormattedMessage id='REPLY' values={{ gender: 'v' }} />
                </button>
                <div className={styles.divider} />
                <button onClick={this.openMore} className={styles.button}>
                    <SVGIcon style={{ image: styles.icon }} src={others} />
                    <FormattedMessage id='BUTTON_LABEL_MORE'>
                        {msg => <span className={styles.more}>{msg}</span>}
                    </FormattedMessage>
                </button>
                <CommentMore post={post} id={comment.id} open={moreOpen} onClose={this.closeMore} />
            </div>
        );
    }
}

export default Styled(defaultStyles)(Footer);
